import React, { useEffect } from 'react';
import { Customer, ProductInstance } from '../../../../util/types.ts';
import { TechValues } from '../../../../util/SelfcareErrorReportTypes.ts';
import { formatDate } from '../../../../util/formatter.ts';

interface CustomerProductSelectionProps {
    customer: Customer;
    tech: string;
    setTech: (tech: string) => void;
    onProductSelect: (product: ProductInstance) => void;
    rateLimitedProductIds?: number[];
}

const CustomerProductSelectionComponent: React.FC<CustomerProductSelectionProps> = ({
            customer,
            tech,
            setTech,
            onProductSelect,
            rateLimitedProductIds
        }) => {
    const activeProductInstances = customer.product_instances.filter(
        instance =>
            instance.product_instance_status === 'ACTIVE' &&
            instance.product.att_statistics_technology !== null
    );

    useEffect(() => {
        if (activeProductInstances.length === 1) {
            const activeProduct = activeProductInstances[0];
            if (rateLimitedProductIds?.includes(activeProduct.product_instance_id)) {
                setTech('');
            } else {
                let tech = activeProduct.product.att_statistics_technology!;
                if (tech !== TechValues.Coax && tech !== TechValues.Fiber) {
                    tech = TechValues.Other;
                }
                setTech(tech);
                onProductSelect(activeProduct);
            }
        }
    }, [activeProductInstances, rateLimitedProductIds, setTech, onProductSelect]);

    const handleTechChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let selectedTech = event.target.value;
        if (selectedTech !== TechValues.Coax && selectedTech !== TechValues.Fiber) {
            selectedTech = TechValues.Other;
        }
        setTech(selectedTech);

        const selectedProduct = activeProductInstances.find(instance => {
            const tech = instance.product.att_statistics_technology;
            return (
                tech === selectedTech ||
                (selectedTech === TechValues.Other && (tech === TechValues.MBB || tech === TechValues.Dsl))
            );
        });

        if (selectedProduct) {
            onProductSelect(selectedProduct);
        }
    };

    return (
        activeProductInstances.length > 1 && (
            <div className={'input-container'}>
                <p>Vælg det produkt, du vil fejlmelde*</p>
                {activeProductInstances.map(instance => (
                    <p key={instance.product_instance_id} className={'with-checkbox'}>
                        <input
                            type={'radio'}
                            id={`product-instance-${instance.product_instance_id}`}
                            name={'product'}
                            value={instance.product.att_statistics_technology ?? ''}
                            checked={
                                tech === (
                                    instance.product.att_statistics_technology !== TechValues.Coax &&
                                    instance.product.att_statistics_technology !== TechValues.Fiber
                                        ? TechValues.Other
                                        : instance.product.att_statistics_technology
                                )
                            }
                            onChange={handleTechChange}
                            disabled={rateLimitedProductIds?.includes(instance.product_instance_id)}

                        />
                        <label
                            htmlFor={`product-instance-${instance.product_instance_id}`}
                            className={'checkbox-label checkbox-label--montserrat'}
                        >
                            {instance.product.product_display_name}
                            <span className={'small'}>
                            Aktiveret d. {formatDate(instance.product_instance_status_active_date as string)}
                        </span>
                            {rateLimitedProductIds?.includes(instance.product_instance_id) && (
                                <span className="error-message">Du har allerede for nyligt fejlmeldt denne forbindelse. Du kan først oprette en ny fejlmelding når vi har behandlet din sag.</span>
                            )}
                        </label>
                    </p>
                ))}
            </div>
        )
    ) || (
        rateLimitedProductIds?.includes(activeProductInstances[0].product_instance_id) && (
            <div className={'input-container'}>
                <p>Vælg det produkt, du vil fejlmelde*</p>
                <p key={activeProductInstances[0].product_instance_id} className={'with-checkbox'}>
                    <input
                        type={'radio'}
                        id={`product-instance-${activeProductInstances[0].product_instance_id}`}
                        name={'product'}
                        value={activeProductInstances[0].product.att_statistics_technology ?? ''}
                        checked={false}
                        disabled={true}
                    />
                    <label
                        htmlFor={`product-instance-${activeProductInstances[0].product_instance_id}`}
                        className={'checkbox-label checkbox-label--montserrat'}
                    >
                        {activeProductInstances[0].product.product_display_name}
                        <span className={'small'}>
                    Aktiveret d. {formatDate(activeProductInstances[0].product_instance_status_active_date as string)}
                </span>
                        <span className="error-message">Du har allerede for nyligt fejlmeldt denne forbindelse. Du kan først oprette en ny fejlmelding når vi har behandlet din sag.</span>
                    </label>
                </p>
            </div>
        )
    )
};

export default CustomerProductSelectionComponent;
